import { StyledEngineProvider } from '@mui/material'
import { PropsWithChildren } from 'react'
import ScrollTop from '../../../components/ScrollTop'
import Appbar from './AppBar'
import Footer from './Footer'

/**
 * Renders Layout
 * @param props Component properties with child components
 */

export default function Layout(props: PropsWithChildren<{}>) {
  return (
    <StyledEngineProvider injectFirst>
      <ScrollTop />
      <Appbar />
      {props.children}
      <Footer />
    </StyledEngineProvider>
  )
}
